import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ViLoaderComponent } from '@vi-iot/ui';
import { PDFDocumentProxy, PDFProgressData, PdfViewerModule } from 'ng2-pdf-viewer';
import { saveAs } from 'file-saver-es';
import { CommonStandaloneModule } from '../../common-standalone.module';

export enum ZoomScaleMode {
  pageWidth = 'page-width',
  pageFit = 'page-fit',
}

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ViLoaderComponent,
    PdfViewerModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class PdfPreviewComponent implements OnInit {
  @Input() src: string;
  @Input() originalSize: boolean;
  @Input() zoom: number;
  @Input() showAll: boolean;
  @Input() showBorders: boolean;
  @Input() autoresize: boolean;
  @Input() page: number;
  @Input() allowNavigation = false;
  @Input() allowZoomScale = false;
  @Input() allowDownload = false;
  @Input() gtmAction = 'Pdf Preview';
  @Input() gtmCategory = 'pdfPreview';
  @Input() documentTitle: string;
  @Output() pageChanged = new EventEmitter<void>();

  pdfLoaded = false;
  progressPercentage = 0;
  totalPages = 0;
  currentPage = 1;
  zoomScale: ZoomScaleMode = ZoomScaleMode.pageFit;
  readonly zoomScaleMode = ZoomScaleMode;

  constructor() {}

  ngOnInit(): void {
    if (this.page) {
      this.currentPage = this.page;
    }
  }

  downloadServiceInstructionFile(url: any): void {
    if (this.allowDownload) {
      if (url instanceof ArrayBuffer) {
        const blob = new Blob([url], { type: 'application/pdf' });
        const fileName = this.documentTitle ?? 'document';

        saveAs(blob, `${fileName}.pdf`);
      } else {
        const urlSplitted = url.split('/');
        const fileName = urlSplitted[urlSplitted.length - 1];

        saveAs(url, fileName);
      }
    }
  }

  onProgress(progressData: PDFProgressData): void {
    this.progressPercentage = Math.round((100 * progressData.loaded) / progressData.total);
    if (progressData.loaded === progressData.total) {
      this.pdfLoaded = true;
    }
  }

  afterLoadComplete(pdf: PDFDocumentProxy): void {
    this.totalPages = pdf.numPages;
  }

  pageChange(event: any): void {
    this.currentPage = event.pageNumber || event;
  }

  goToPreviousPage(): void {
    if (this.allowNavigation && this.currentPage > 1) {
      this.currentPage--;
      this.pageChanged.emit();
    }
  }

  goToNextPage(): void {
    if (this.allowNavigation && this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pageChanged.emit();
    }
  }

  toggleZoomMode(): void {
    if (this.allowZoomScale) {
      if (this.zoomScale === ZoomScaleMode.pageFit) {
        this.zoomScale = ZoomScaleMode.pageWidth;
      } else {
        this.zoomScale = ZoomScaleMode.pageFit;
      }
    }
  }
}
